import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPercent = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 19,
			y1: 5,
			x2: 5,
			y2: 19
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.5,
			cy: 6.5,
			r: 2.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17.5,
			cy: 17.5,
			r: 2.5
		})
	]
});
export default SvgPercent;
